export default function buttonLayoutStyle(_a) {
    var _b, _c;
    var isRtl = _a.isRtl, alignStart = _a.alignStart;
    var halfX = 8;
    var flexDirection = alignStart ? 'row' : 'row-reverse';
    var start;
    if (alignStart) {
        start = isRtl ? 'Right' : 'Left';
    }
    else {
        start = isRtl ? 'Left' : 'Right';
    }
    var end = start === 'Right' ? 'Left' : 'Right';
    var container = {
        direction: isRtl ? 'rtl' : 'ltr',
        padding: halfX + " 0 " + halfX + " 0",
        display: 'flex',
        flexDirection: flexDirection,
        flexWrap: 'wrap',
        width: '100%',
        alignItems: 'center'
    };
    var item = (_b = {},
        _b["padding" + end] = '16px',
        _b.margin = halfX + " 0 " + halfX + " 0",
        _b['&:last-child'] = (_c = {}, _c["padding" + end] = 0, _c),
        _b);
    return { container: container, item: item };
}
